import type { RouteRecordRaw } from 'vue-router';
import core from './modules/core/router/routes';
import offer from './modules/offer/router/routes';
import parcel from './modules/parcel/router/routes';
import subscription from './modules/subscription/router/routes';
import webshopOrder from './modules/webshop-order/router/routes';
import { authRoutes, authMainRoutes } from '@shared';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    children: [
      {
        path: '',
        component: () => import('./components/layouts/MainLayout.vue'),
        children: [...core, ...offer, ...parcel, ...subscription, ...webshopOrder, ...authMainRoutes]
      },
      {
        path: '',
        component: () => import('./components/layouts/LoginLayout.vue'),
        children: [...authRoutes]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('./modules/core/pages/ErrorPage.vue')
  }
];

export default routes;
